import React, { useState } from 'react';
import AppSpinner from "../Spinner/AppSpinner";
import { Modal, Button, Form } from 'react-bootstrap';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";

const AddNewTrainingModal = ({ show, onHide, onSuccess }) => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await apiFetch(`${BASE_URL}/trainings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({ name: '', description: '' });
        onSuccess();
        onHide();
      } else {
        alert("Əlavə edilərkən xəta baş verdi.");
      }
    } catch (err) {
      console.error("Server xətası:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton style={{
        background: '#f3f4f6',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px 20px'
      }}>
        <Modal.Title style={{ fontWeight: '700', color: '#374151', fontSize: '15px' }}>
          Yeni Təlim Əlavə Et
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body style={{ padding: '20px', background: '#fff' }}>
          <div className="row g-3">
            <div className="col-md-12">
              <Form.Group>
                <Form.Label style={{ fontWeight: '600', color: '#374151', fontSize: '12px', textTransform: 'uppercase', marginBottom: '4px' }}>
                  Təlim Adı
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Məsələn: Java Proqramlaşdırma"
                  style={{ borderRadius: '6px', padding: '8px 12px', fontSize: '13px', border: '1px solid #d1d5db' }}
                />
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group>
                <Form.Label style={{ fontWeight: '600', color: '#374151', fontSize: '12px', textTransform: 'uppercase', marginBottom: '4px' }}>
                  Təsvir
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Təlim haqqında ətraflı məlumat daxil edin..."
                  style={{ borderRadius: '6px', padding: '8px 12px', fontSize: '13px', border: '1px solid #d1d5db' }}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ background: '#f3f4f6', borderTop: '1px solid #e5e7eb', padding: '10px 16px' }}>
          <Button
            variant="secondary"
            onClick={onHide}
            style={{ fontWeight: '600', borderRadius: '6px', fontSize: '12px', padding: '6px 16px' }}
          >
            Ləğv et
          </Button>
          <Button
            type="submit"
            disabled={saving}
            style={{
              fontWeight: '600',
              borderRadius: '6px',
              fontSize: '12px',
              padding: '6px 20px',
              background: '#22c55e',
              border: 'none',
              color: '#fff'
            }}
          >
            {saving ? <AppSpinner inline /> : 'Əlavə et'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddNewTrainingModal;